import io from "socket.io-client";

class Socket {
    com?: ReturnType<typeof io>
    start() {
        this.com = io(process.env.NODE_ENV === "development" ? "http://localhost:3002/" : "/");
    }
    stop() {
        this.com!.disconnect();
        this.com!.close();
    }
}

export default new Socket();
